module.exports = __webpack_public_path__ + "img/1.5eb32d0d.png";